<div class="section" style="flex: 1; display: flex; flex-direction: column; background-color: #ffffff !important;" data-cy="insurance-rtb-container">
  <div class="section-header" style="flex-basis: fit-content;" data-cy="insurance-rtb-header">
    <div class="section-header-title" data-cy="insurance-rtb-title">
      Real Time Benefits Request
    </div>
  </div>

  <div style="display: flex; padding: 10px" data-cy="insurance-rtb-provider-section">
    <div style="flex:2; padding-right:10px" data-cy="insurance-rtb-provider-selector">
      <div class="input-container-height" data-cy="insurance-rtb-provider-field">
        <mat-form-field floatLabel='never'  [style.width.%]="100" data-cy="insurance-rtb-provider-form-field">
          <mat-label data-cy="insurance-rtb-provider-label">Select Provider</mat-label>
          <mat-select [(ngModel)]="currentDoctor" data-cy="insurance-rtb-provider-select">
            <mat-option *ngFor="let dr of doctorList" [value]="dr" data-cy="insurance-rtb-provider-option-{{dr.index}}">
              {{ dr.dataContact.FirstName + ' ' + dr.dataContact.LastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div style="flex:1" data-cy="insurance-rtb-show-button-container">
      <button class="tdo-button tdo-save" (click)="loadRTBService2()" data-cy="insurance-rtb-show-button">Show Information</button>
    </div>
  </div>

  <div *ngIf="!this.isLoading && !jsonResp;" style="height: 550px" data-cy="insurance-rtb-empty-content">

  </div>

  <div *ngIf="!isLoading && jsonResp" style="overflow-y: auto; height:560px; padding: 10px 10px 10px 10px" data-cy="insurance-rtb-content">

    <div *ngIf="jsonResp.ValidationLogItems.length > 0" data-cy="insurance-rtb-validation-errors">
<!--      show missing info-->
      <b data-cy="insurance-rtb-error-title">DentalXChange Error</b>
      <br>
      <span data-cy="insurance-rtb-error-message">The following information is needed to lookup eligibility:</span>
      <ul *ngFor="let err of jsonResp.ValidationLogItems" data-cy="insurance-rtb-error-list">
        <li data-cy="insurance-rtb-error-item-{{err.index}}">
          {{ err.ValidationItemName }}
        </li>
      </ul>
    </div>
    <div *ngIf="jsonResp.messages" data-cy="insurance-rtb-messages-container">
      <div *ngIf="jsonResp.messages.length > 0" data-cy="insurance-rtb-messages">
        <!--      show missing info-->
        <b data-cy="insurance-rtb-messages-title">DentalXChange Error</b>
        <ul *ngFor="let err of jsonResp.messages" data-cy="insurance-rtb-messages-list">
          <li data-cy="insurance-rtb-message-item-{{err.index}}">
            {{ err }}
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="jsonResp.ValidationLogItems.length === 0 && jsonResp.response" data-cy="insurance-rtb-response">
      <div *ngIf="jsonResp.response.patient" data-cy="insurance-rtb-patient">
        <div class="eligibility-section-header" data-cy="insurance-rtb-patient-header">Patient</div>

        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-name-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-name-label">Name</div>
          <div style="flex:2" data-cy="insurance-rtb-patient-name-value">{{ jsonResp.response.patient.firstName + ' ' + patientEligibilityResponse.response.patient.lastName }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-address-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-address-label">Address</div>
          <div style="flex:2; white-space: pre-line" data-cy="insurance-rtb-patient-address-value">{{ jsonResp.response.patient.address ? returnAddress(jsonResp.response.patient.address) : '' }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-dob-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-dob-label">DOB</div>
          <div style="flex:2" data-cy="insurance-rtb-patient-dob-value">{{ jsonResp.response.patient.dateOfBirth }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-gender-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-gender-label">Gender</div>
          <div style="flex:2" data-cy="insurance-rtb-patient-gender-value">{{ jsonResp.response.patient.gender }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-relationship-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-relationship-label">Relationship</div>
          <div style="flex:2" data-cy="insurance-rtb-patient-relationship-value">{{ jsonResp.response.patient.relationship }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-patient-plan-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-patient-plan-label">Plan</div>
          <div style="flex:2" data-cy="insurance-rtb-patient-plan-value">{{ jsonResp.response.patient.plan ? returnPlan(jsonResp.response.patient.plan) : ''}}</div>
        </div>
      </div>

      <div *ngIf="jsonResp.response.subscriber" data-cy="insurance-rtb-subscriber">
        <div class="eligibility-section-header" data-cy="insurance-rtb-subscriber-header">Subscriber</div>

        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-name-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-name-label">Name</div>
          <div style="flex:2" data-cy="insurance-rtb-subscriber-name-value">{{ jsonResp.response.subscriber.firstName + ' ' + patientEligibilityResponse.response.subscriber.lastName }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-address-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-address-label">Address</div>
          <div style="flex:2; white-space: pre-line" data-cy="insurance-rtb-subscriber-address-value">{{ jsonResp.response.subscriber.address ? returnAddress(jsonResp.response.subscriber.address) : '' }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-dob-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-dob-label">DOB</div>
          <div style="flex:2" data-cy="insurance-rtb-subscriber-dob-value">{{ jsonResp.response.subscriber.dateOfBirth }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-gender-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-gender-label">Gender</div>
          <div style="flex:2" data-cy="insurance-rtb-subscriber-gender-value">{{ jsonResp.response.subscriber.gender }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-relationship-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-relationship-label">Relationship</div>
          <div style="flex:2" data-cy="insurance-rtb-subscriber-relationship-value">{{ jsonResp.response.subscriber.relationship }}</div>
        </div>
        <div *ngIf="jsonResp.response.subscriber.plan" style="display: flex; flex-direction: row" data-cy="insurance-rtb-subscriber-plan-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-subscriber-plan-label">Plan</div>
          <div style="flex:2" data-cy="insurance-rtb-subscriber-plan-details">
            <app-insurance-rtb-dialog-plan-details [jsonResp]="jsonResp.response.subscriber.plan" data-cy="insurance-rtb-subscriber-plan-component"></app-insurance-rtb-dialog-plan-details>
          </div>
        </div>
      </div>

      <div *ngIf="jsonResp.response.payer" data-cy="insurance-rtb-payer">
        <div class="eligibility-section-header" data-cy="insurance-rtb-payer-header">Payer</div>

        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-payer-name-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-payer-name-label">Name</div>
          <div style="flex:2" data-cy="insurance-rtb-payer-name-value">{{ jsonResp.response.payer.name ? jsonResp.response.payer.name : '' }}</div>
        </div>
        <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-payer-id-row">
          <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-payer-id-label">ID Code</div>
          <div style="flex:2" data-cy="insurance-rtb-payer-id-value">{{ jsonResp.response.payer.name ? jsonResp.response.payer.payerIdCode : '' }}</div>
        </div>
      </div>

      <div *ngIf="jsonResp.response.activeCoverage && jsonResp.response.activeCoverage.length > 0" data-cy="insurance-rtb-active-coverage">
        <div class="eligibility-section-header" data-cy="insurance-rtb-active-coverage-header">Active Coverage</div>

        <div *ngFor="let coverage of jsonResp.response.activeCoverage; let i = index" style="border-top: solid 2px #cccccc" data-cy="insurance-rtb-coverage-item-{{i}}">
          <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-coverage-service-row-{{i}}">
            <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-coverage-service-label-{{i}}">Service Type</div>
            <div style="flex:2" data-cy="insurance-rtb-coverage-service-value-{{i}}">{{ coverage.serviceType ? coverage.serviceType : '' }}</div>
          </div>
          <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-coverage-level-row-{{i}}">
            <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-coverage-level-label-{{i}}">Coverage Level</div>
            <div style="flex:2" data-cy="insurance-rtb-coverage-level-value-{{i}}">{{ coverage.coverageLevel ? coverage.coverageLevel : '' }}</div>
          </div>
          <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-coverage-desc-row-{{i}}">
            <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-coverage-desc-label-{{i}}">Coverage Description</div>
            <div style="flex:2" data-cy="insurance-rtb-coverage-desc-value-{{i}}">{{ coverage.planCoverageDescription ? coverage.planCoverageDescription : '' }}</div>
          </div>
          <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-coverage-type-row-{{i}}">
            <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-coverage-type-label-{{i}}">Insurance Type</div>
            <div style="flex:2" data-cy="insurance-rtb-coverage-type-value-{{i}}">{{ coverage.insuranceType ? coverage.insuranceType : '' }}</div>
          </div>
          <div style="display: flex; flex-direction: row" data-cy="insurance-rtb-coverage-message-row-{{i}}">
            <div style="flex:1" class="eligibility-section-item-name" data-cy="insurance-rtb-coverage-message-label-{{i}}">Message</div>
            <div style="flex:2" data-cy="insurance-rtb-coverage-message-value-{{i}}">{{ coverage.message ? coverage.message : '' }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="jsonResp.response.coInsurance && jsonResp.response.coInsurance.length > 0" data-cy="insurance-rtb-coinsurance">
        <div class="eligibility-section-header" data-cy="insurance-rtb-coinsurance-header">CoInsurance</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.coInsurance" data-cy="insurance-rtb-coinsurance-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <div *ngIf="jsonResp.response.deductible && jsonResp.response.deductible.length > 0" data-cy="insurance-rtb-deductible">
        <div class="eligibility-section-header" data-cy="insurance-rtb-deductible-header">Deductible</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.deductible" data-cy="insurance-rtb-deductible-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <div *ngIf="jsonResp.response.benefitDescription && jsonResp.response.benefitDescription.length > 0" data-cy="insurance-rtb-benefit-description">
        <div class="eligibility-section-header" data-cy="insurance-rtb-benefit-description-header">Benefit Description</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.benefitDescription" data-cy="insurance-rtb-benefit-description-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <div *ngIf="jsonResp.response.limitationAndMaximum && jsonResp.response.limitationAndMaximum.length > 0" data-cy="insurance-rtb-limitation">
        <div class="eligibility-section-header" data-cy="insurance-rtb-limitation-header">Limitation & Maximum</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.limitationAndMaximum" data-cy="insurance-rtb-limitation-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <div *ngIf="jsonResp.response.notCovered && jsonResp.response.notCovered.length > 0" data-cy="insurance-rtb-not-covered">
        <div class="eligibility-section-header" data-cy="insurance-rtb-not-covered-header">Not Covered</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.notCovered" data-cy="insurance-rtb-not-covered-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <div *ngIf="jsonResp.response.otherBenefit && jsonResp.response.otherBenefit.length > 0" data-cy="insurance-rtb-other-benefit">
        <div class="eligibility-section-header" data-cy="insurance-rtb-other-benefit-header">Other Benefit</div>
        <app-insurance-rtb-dialog-plan-benefit-details [jsonResp]="jsonResp.response.otherBenefit" data-cy="insurance-rtb-other-benefit-details"></app-insurance-rtb-dialog-plan-benefit-details>
      </div>

      <!--    <div class="eligibility-section-header">Plan Dates</div>-->

      <!--    <div style="display: flex; flex-direction: row">-->
      <!--      <div style="flex:1">date1</div>-->
      <!--      <div style="flex:2">5/2/1979</div>-->
      <!--      <div style="flex:1">&nbsp;</div>-->
      <!--      <div style="flex:2">&nbsp;</div>-->
      <!--    </div>-->
    </div>

  </div>

  <div *ngIf="isLoading" class="loading-spinner" data-cy="insurance-rtb-loading">
    <mat-spinner [diameter]="100" data-cy="insurance-rtb-spinner"></mat-spinner>
  </div>

  <mat-dialog-actions  *ngIf="!isLoading" align="end" style="padding: 10px 10px 10px 10px" data-cy="insurance-rtb-actions">
    <button (click)="closeWindow()" class="tdo-button tdo-close" color="primary" tabindex="-1" data-cy="insurance-rtb-close-button">Close Window</button>
  </mat-dialog-actions>
</div>
